import * as React from "react";
import { forwardRef } from "react";
import { chakra, useStyleConfig } from "@chakra-ui/react";
export const CopyIcon = forwardRef(({ baseline = false, ...props }, ref) => {
    const styles = useStyleConfig("HightouchIcon");
    if (baseline) {
        styles.top = "0.125em";
        styles.position = "relative";
    }
    return React.createElement(chakra.svg, { __css: styles, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", ref: ref, ...props },
        React.createElement("path", { fillRule: "evenodd", d: "M10.333 5a.778.778 0 0 0-.777.778v8.889c0 .43.348.777.777.777h7.111c.43 0 .778-.348.778-.777V8.859L14.364 5h-4.03Zm-2.777.778A2.778 2.778 0 0 1 10.333 3h4.077c.5 0 .981.199 1.335.553l3.924 3.924c.354.354.553.835.553 1.336v5.854a2.778 2.778 0 0 1-2.778 2.777h-.777V18a3 3 0 0 1-3 3h-6.89A2.778 2.778 0 0 1 4 18.222V9.556a3 3 0 0 1 3-3h.556v-.778Zm0 2.778H7a1 1 0 0 0-1 1v8.666c0 .43.348.778.778.778h6.889a1 1 0 0 0 1-1v-.556h-4.334a2.778 2.778 0 0 1-2.777-2.777V8.556Z", clipRule: "evenodd" }));
});
CopyIcon.displayName = "CopyIcon";
